import { LocalNotifications } from '@capacitor/local-notifications';
import { Capacitor } from '@capacitor/core';

export const showNativeNotification = async (
  title: string,
  body: string,
  data?: Record<string, any>
) => {
  // Only show notifications on native platforms (Android/iOS)
  if (!Capacitor.isNativePlatform()) return;

  try {
    // Check permissions first
    const permStatus = await LocalNotifications.checkPermissions();
    
    if (permStatus.display !== 'granted') {
      const requested = await LocalNotifications.requestPermissions();
      if (requested.display !== 'granted') return;
    }

    // Schedule the notification
    await LocalNotifications.schedule({
      notifications: [
        {
          title,
          body,
          id: Date.now(),
          schedule: { at: new Date() },
          extra: data
        }
      ]
    });
  } catch (error) {
    console.error('Error showing native notification:', error);
  }
};

// Setup notification click handler
export const setupNotificationHandlers = () => {
  if (!Capacitor.isNativePlatform()) return;

  LocalNotifications.addListener('localNotificationActionPerformed', (notification) => {
    // Handle notification click
    const data = notification.notification.extra;
    
    // If there's a deep link, handle it
    if (data?.deepLink) {
      window.location.href = data.deepLink;
    }
  });
}; 